import { useMemo } from 'react';

export const useStableArray = (
	stringArray: string[],
	{
		sort,
		deduplicate,
		sortFunction = (a: string, b: string) => a.localeCompare(b),
	}: {
		sort: boolean;
		deduplicate: boolean;
		sortFunction?: (a: string, b: string) => number;
	},
): string[] => {
	const separator = '___@@@$$@@@___'; // unique separator to avoid conflicts with other strings

	const stableItemsString = useMemo(() => {
		let items = [...stringArray];
		if (deduplicate) {
			items = [...new Set(items)];
		}
		if (sort) {
			items.sort(sortFunction);
		}
		return items.join(separator);
	}, [stringArray, sort, separator, deduplicate, sortFunction]);

	return useMemo(
		() => (stableItemsString.length ? stableItemsString.split(separator) : []),
		[stableItemsString],
	);
};
